module.exports = __webpack_public_path__ + "static/media/sernapesca-caletaenlinea-flags.540ba6fa.png";